import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

const LockIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 25 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.5 4.5C10.8431 4.5 9.5 5.84315 9.5 7.5V9H15.5V7.5C15.5 5.84315 14.1569 4.5 12.5 4.5ZM17 9V7.5C17 5.01472 14.9853 3 12.5 3C10.0147 3 8 5.01472 8 7.5V9H5.75C4.50736 9 3.5 10.0074 3.5 11.25V18.75C3.5 19.9926 4.50736 21 5.75 21H19.25C20.4926 21 21.5 19.9926 21.5 18.75V11.25C21.5 10.0074 20.4926 9 19.25 9H17ZM5.75 10.5C5.33579 10.5 5 10.8358 5 11.25V18.75C5 19.1642 5.33579 19.5 5.75 19.5H19.25C19.6642 19.5 20 19.1642 20 18.75V11.25C20 10.8358 19.6642 10.5 19.25 10.5H5.75Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default LockIcon;
